import axios from '@/api';
import authHeader from './auth-header';
import * as FilesApi from "@/api/files.api";

export function normalizeFile(item, currentDir) {
    return {
        path: currentDir || "/",
        name: item.file?.name ?? item.name,
        type: item.type,
        isFile: item.isFile,
        meta: item.meta
    };
}

function mapFileListResponse(request) {
    return request.then(res => ({
        currentDir: res.data.currentDir,
        files: res.data.files.map(item =>
            normalizeFile(item, res.data.currentDir)
        )
    }));
}

class FileService {
    getFileContent(buttonName, buttonType) {
        return mapFileListResponse(
            FilesApi.getFileContent(buttonName, buttonType)
        );
    }

    getFolderSize(dir) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/folderSize',
            {
                dir: dir
            },
            {
                headers: authHeader(),
                withCredentials: true
            }
        ).then(response => {
            return response.data;
        })
            .catch(error => {
                throw error;
            });
    }

    postFileDownChk(fileName) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileDownChk', {
            fileName
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return response;
            }).catch(error => {
                console.log(error);
            })
    }

    async getFileDown(file) {
        const downloadUrl = `${process.env.VUE_APP_API_URL}file/fileDown?name=${encodeURIComponent(file)}`;
        
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = file;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }

    async postFileDownload(file, options = {}) {
        return new Promise((resolve, reject) => {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = process.env.VUE_APP_API_URL + 'file/fileDown';
            form.target = options.target || '_blank';
            form.style.display = 'none';

            // 파일 이름 또는 기타 필드
            const fileInput = document.createElement("input");
            fileInput.name = "name";
            fileInput.value = file;
            form.appendChild(fileInput);

            // 인증 토큰을 input으로 전달 (예: JWT)
            const headers = authHeader();
            if (headers['x-access-token']) {
                const tokenInput = document.createElement("input");
                tokenInput.name = "x-access-token";  // 서버에서 이 필드를 읽어야 함
                tokenInput.value = headers['x-access-token'];
                form.appendChild(tokenInput);
            }

            document.body.appendChild(form);

            try {
                form.submit();
                resolve();
            } catch (error) {
                reject(error);
            } finally {
                setTimeout(() => {
                    document.body.removeChild(form);
                }, 1000);
            }
        });
    }

    postFileOpen(file) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileDownChk',
            {

            },
            {
                headers: authHeader(),
                withCredentials: true,
            }).then(response => {
                if (response.status == 200) {
                    var newForm = document.createElement("form");
                    newForm.setAttribute("method", "POST");
                    newForm.setAttribute("action", process.env.VUE_APP_API_URL + 'file/fileOpen')

                    var newInput = document.createElement("input");
                    newInput.setAttribute('type', 'hidden');
                    newInput.setAttribute("name", "name");
                    //newInput.setAttribute("value", file.name);
                    newInput.setAttribute("value", file);
                    newForm.appendChild(newInput);

                    document.body.appendChild(newForm);
                    newForm.submit();
                    document.body.removeChild(newForm);
                    //console.log(newInput.textContent);
                    return newInput.textContent
                }
            });
    }

    postTextOpen(file, filePath, offset, limit, token) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/textOpen',
            {
                fileName: file,
                filePath,
                offset,
                limit,
                token,
            },
            {
                headers: authHeader(),
                withCredentials: true,
            }).then(response => {
                //console.log(response.data);
                return response.data;
        });
    }

    async postFileUpload(formData, onProgress) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_API_URL + 'file/fileUpload',
                formData,
                {
                    onUploadProgress: (e) => {
                        if (onProgress) onProgress(e);
                    },
                    headers: {
                        ...authHeader(),
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                    maxContentLength: Infinity,
                    maxBodyLength: Infinity,
                    timeout: 0,
                }
            );

            return response;
        } catch (e) {
            console.error('postFileUpload error:', e);
            throw e;
        }
    }

    //resetUploadProgress() {
    //    store.state.files.upload.uploadedBytes = 0;
    //    store.dispatch('files/upload/setUploadPercent', '0');
    //}

    postFileRecycle(files, oldDir, isForceDelete) {
        return mapFileListResponse(
            FilesApi.postFileRecycle(files, oldDir, isForceDelete)
        );
    }

    postFileDelete(files) {
        return mapFileListResponse(
            FilesApi.postFileDelete(files)
        );
    }


    async createFolder(newDirName, currentDir) {
        const res = await FilesApi.postFolderCreate(newDirName);

        return normalizeFile(res.data[0], currentDir);
    }

    getAllFilesInFolder(oldDir, folder) {
        return FilesApi
            .getAllFilesInFolder(oldDir, folder)
            .then(res => res.data);
    }


    moveFile(oldDir, newDir, subDir, file) {
        return FilesApi
            .moveFile(
                oldDir,
                newDir,
                subDir,
                file
            )
            .then(res =>
                normalizeFile(
                    res.data,
                    newDir
                )
            );
    }

    copyFile(oldDir, newDir, subDir, file) {
        return FilesApi
            .copyFile(
                oldDir,
                newDir,
                subDir,
                file
            )
            .then(res =>
                normalizeFile(
                    res.data,
                    newDir
                )
            );
    }


    postFileCopy(moveArray, newDir) {
        moveArray = JSON.parse(JSON.stringify(moveArray))
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileCopy', {
            moveArray,
            newDir,
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return response.data;
            }).catch(error => {
                console.log(error);
            })
    }

    postMediaOpen(fileName, mediaToken) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/mediaOpen', {
            fileName,
            mediaToken
        },
        {
            headers: authHeader(),
            withCredentials: true
            }).then(res => {
            return res;
        }).catch(error => {
            console.log(error);
        })
    }

    postFileRename(oldName, newName, currentDir) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileRename', {
            oldName,
            newName,
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return normalizeFile(
                    response.data[0],
                    currentDir
                );
            }).catch(error => {
                console.log(error);
            })
    }

    //getFileLink(file) {
    //    return axios.get(process.env.VUE_APP_API_URL + 'file/images',
    //        {
    //            //params: { file: file },
    //            params: { file: file },
    //            headers: authHeader(),
    //            withCredentials: true
    //        }).then(response => {
    //            //console.log(response.data)
    //            return response.data
    //        });
    //}

    postCreateLinkToken(fileName, dir) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/createLink', {
            fileName,
            dir,
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(res => {
                return res.data;
            }).catch(error => {
                console.log(error);
            })
    }

    // ⭐ 새로 추가: ZIP 엔트리 가져오기
    postZipEntries(zipFilename, token, dir) {
        return axios.post(process.env.VUE_APP_API_URL + "file/zip/entries", {
            token,
            dir,
            zipFilename,
        }, {
            headers: authHeader(),
            withCredentials: true
        })
            .then(res => res.data)
            .catch(err => {
                console.error(err);
            });
    }

    // 파일 스트림 URL 반환
    getZipFileUrl(zipFilename, token, curZipDir, fileName) {
        return `${process.env.VUE_APP_API_URL}file/zip/file`
            + `?token=${token}`
            + `&curZipDir=${encodeURIComponent(curZipDir)}`
            + `&zipFilename=${encodeURIComponent(zipFilename)}`
            + `&fileName=${encodeURIComponent(fileName)}`;
    }

    logout() {
        localStorage.removeItem('files');
    }
}

export default new FileService();